import React, { useState, useEffect } from "react";
import "./create_account.css";
import { useNavigate, useLocation } from "react-router-dom";
import { CreateAccountMobileStep2 } from './create_account_steps.mobile.js';

export default function AccountPasswords() {
  const navigate = useNavigate();
  const location = useLocation();
  const step1Data = location.state || {};

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  //  التحقق أثناء الكتابة
  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedData = {
      ...formData,
      [name]: value,
    };

    setFormData(updatedData);

    let newErrors = { ...errors };

    //  كلمة المرور
    if (name === "password") {
      if (!value) {
        newErrors.password = "هذا الحقل مطلوب";
      }  if (value.length < 6) {
        newErrors.password = "يجب أن تكون 6 أحرف على الأقل";
      } else {
        delete newErrors.password;
      }
    }

    //  تأكيد كلمة المرور
    if (name === "confirmPassword") {
      if (!value) {
        newErrors.confirmPassword = "هذا الحقل مطلوب";
      } else if (value !== updatedData.password) {
        newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
      } else {
        delete newErrors.confirmPassword;
      }
    }

    //  مهم: إعادة التحقق عند تعديل password
    if (name === "password" && updatedData.confirmPassword) {
      if (updatedData.confirmPassword !== value) {
        newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
      } else {
        delete newErrors.confirmPassword;
      }
    }

    setErrors(newErrors);
  };

  //  التحقق عند الضغط على الزر
const validate = () => {
  let newErrors = {};

  if (!formData.password) {
    newErrors.password = "هذا الحقل مطلوب";
  } else if (formData.password.length < 6) {
    newErrors.password = "يجب أن تكون 6 أحرف على الأقل";
  }

  if (!formData.confirmPassword) {
    newErrors.confirmPassword = "هذا الحقل مطلوب";
  } else if (formData.password !== formData.confirmPassword) {
    newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault(); // تعديل هنا لتفادي الخطأ في الموبايل

    if (!validate()) return;

    navigate("/create-account-step3", { state: { ...step1Data, ...formData } });
  };
  if (isMobile) {
    return (
      <CreateAccountMobileStep2
        formData={formData}
        handleChange={handleChange} /* إضافة */
        errors={errors} /* إضافة */
        onNext={handleNext}
      />
    );
  }
 
  return (
    <div className="create-account-container" dir="ltr">
      <div className="create-account-left">
        <form className="create-account-form">
          <h3 className="create-account-h3">إنشاء حساب جديد</h3>

          {/* 🔹 كلمة المرور */}
          <div className="create-account-input-group">
            <i className="fa-solid fa-unlock create-account-icon"></i>

            <input
              type="password"
              autoComplete="new-password"
              placeholder="كلمة المرور"
              name="password"
              onChange={handleChange}
              className={errors.password ? "input error" : "input"}
            />

            {errors.password && (
              <span className="error-text">{errors.password}</span>
            )}
          </div>

          {/* 🔹 تأكيد كلمة المرور */}
          <div className="create-account-input-group">
            <i className="fa-solid fa-lock create-account-icon"></i>

            <input
              type="password"
              placeholder="تأكيد كلمة المرور"
              name="confirmPassword"
              onChange={handleChange}
              className={errors.confirmPassword ? "input error" : "input"}
            />

            {errors.confirmPassword && (
              <span className="error-text">
                {errors.confirmPassword}
              </span>
            )}
          </div>

          <button
            className="create-account-submit-2"
            type="button"
            onClick={handleNext}
          >
            متابعة
          </button>
        </form>

        <p className="create-account-login">
          هل لديك حساب؟ <a href="/login">تسجيل الدخول</a>
        </p>
      </div>

      <div className="create-account-right">
        <img
          className="syria-logo-create-account-logo"
          src="../images/Emblem_of_Syria_(2025–present).svg.png"
          alt="logo"
        />
        <h1 className="create-account-title">
          الجمهورية العربية السورية
        </h1>
        <h4 className="create-account-sub">
          وزارة الصحة - منصة التنبؤ بالأوبئة
        </h4>
      </div>
    </div>
  );
}